import { translate } from '@lucidlink/uicore';
export const getCodeInputDigitAriaLabel = (position, length) => translate('Character {{position}} of {{length}}', { position, length });
